import * as React from 'react';
import { emptyFn } from '../../utils/helper';
export var MenuItemContext = React.createContext({
    itemStyle: undefined,
    clickHandler: emptyFn
});
